// router/Router.js
import { LOCAL_STORAGE_KEY } from 'constants/LocalStorageKeys';
import Homepage from 'pages/Home/Homepage';
import PrivacyPolicy from 'pages/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from 'pages/TermsOfService/TermsOfService';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import { getDataFromLocalStorage } from 'utils/LocalStorage';

// Layouts
const DefaultLayout = React.lazy(() => import('layout/DefaultLayout'));
const VendorLayout = React.lazy(() => import('layout/VendorLayoutComponent/VendorLayout'));

// Auth Pages
const Login = React.lazy(() => import('AuthPages/Login/Login'));
const Register = React.lazy(() => import('AuthPages/Register/Register'));
const ResetPasswordEmail = React.lazy(() => import('AuthPages/ResetPassword/ResetPasswordEmail'));
const ResetPassword = React.lazy(() => import('AuthPages/ResetPassword/ResetPassword'));
const EmailVerification = React.lazy(() => import('views/pages/changeEmail/email'));

// Error Pages
const Page404 = React.lazy(() => import('AuthPages/ErrorPages/Page404/Page404'));
const Page500 = React.lazy(() => import('AuthPages/ErrorPages/Page500/Page500'));

const Router = () => {
  const [loader, setLoader] = useState(false);

  const accessToken = getDataFromLocalStorage(LOCAL_STORAGE_KEY.accessToken);
  const refreshToken = getDataFromLocalStorage(LOCAL_STORAGE_KEY.refreshToken);
  const userData = useSelector(state => state?.userReducer?.userData);

  // Check if user is a vendor
  const isVendor = userData?.isVendor === true;

  return (
    <Routes>
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/home" element={<Homepage />} />
      {!accessToken || !refreshToken ? (
        <>
          <Route path="/" element={<Login loader={loader} setLoader={setLoader} />} />
          <Route path="/login" element={<Login loader={loader} setLoader={setLoader} />} />
          <Route path="/register" element={<Register />} />
          <Route path="/resetpassword" element={<ResetPasswordEmail />} />
          <Route path="/resetpassword/:auth_token" element={<ResetPassword />} />
          <Route path="/verify/email/:token" element={<EmailVerification />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </>
      ) : isVendor ? (
        // Vendor routes - use VendorLayout
        <>
          <Route path="/vendor/*" element={<VendorLayout />} />
          <Route path="*" element={<Navigate to="/vendor/messages" />} />
        </>
      ) : (
        // Regular user routes - use DefaultLayout
        <>
          <Route path="/*" element={<DefaultLayout />} />
        </>
      )}

      <Route path="/404" element={<Page404 />} />
      <Route path="/500" element={<Page500 />} />
    </Routes>
  );
};

export default Router;